import {
  CommonRequest,
  CommonResponse,
  DmlResponse,
  Method,
  ServiceName,
} from 'models/common/RestApi';
import {
  MdIvesArticle,
  MdIvesDtlIspt,
  MdIvesMdlEqpLnIspt,
  MdIvesMdlInfo,
  MdIvesCondition,
  MdIvesMdlCondition,
  MdIvesPrjInfo,
  MdIvesMdlLnEqp,
  MdIvesMdlSmly,
  MdDtlIspt,
  MdIvesPerformanceResult,
  MdIvesPerformanceResultCondition,
  MdIvesMdlSmlyScor,
  MdDtlIsptCondition,
  MdModelSpecInfo,
} from 'models/md/MdIves';
import { callApi } from 'utils/ApiUtil';

/**
 * 형개발 투자비 산출 목록
 * @returns
 */
export const findMdIvesList = async (condition: MdIvesCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesPrjInfo[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesPrjInfo[];
};

/**
 * 형개발 투자비 산출 등록 > 프로젝트 정보 등록
 * @returns
 */
export const saveMdPrjInfo = async (masterData: MdIvesPrjInfo) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/project`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 산출 등록 > 프로젝트 삭제
 * @returns
 */
export const deleteMdPrjInfo = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/project/${elmPrjId}/delete`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 산출 등록 > 프로젝트 정보 조회
 * @returns
 */
export const findMdPrjInfo = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/project/${elmPrjId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<MdIvesPrjInfo> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 산출 등록 > 프로젝트 상태 조회
 * @returns
 */
export const findMdPrjStatCd = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/project/${elmPrjId}/status`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<MdIvesPrjInfo> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 산출 등록 > 형개발 투자비 INPUT 복사
 * @returns
 */
export const copyMdIves = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/${elmPrjId}/copy`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 상태 변경 > 완료
 * @returns
 */
export const completeMdIves = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/${elmPrjId}/complete`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 상태 변경 > drop
 * @returns
 */
export const dropMdIves = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/${elmPrjId}/drop`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 상태 변경 > ing
 * @returns
 */
export const inProgressMdIves = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/${elmPrjId}/ing`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 모델 목록
 * @returns
 */
export const findMdIvesMdlInfoList = async (condition: MdIvesMdlCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/model`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesMdlInfo[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlInfo[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 형개발투자비 프로젝트 모델 사양 상세 조회(형개발 투자비 Input 화면표출용)
 * @returns
 */
export const findMdIvesMdlInfo = async (condition: MdIvesMdlCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/model-detail`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesMdlInfo> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlInfo;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 형개발투자비 프로젝트 모델 사양 저장
 * @returns
 */
export const saveMdIvesMdlInfo = async (masterData: MdModelSpecInfo) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/model`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 형개발투자비 프로젝트 모델 삭제
 * @returns
 */
export const deleteMdMdlInfo = async (masterData: MdIvesMdlInfo) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/model/delete`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 프로젝트 모델 저장
 * @returns
 */
export const saveMdMdlInfo = async (masterData: MdIvesMdlInfo) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/model`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 형개발투자비 프로젝트 모델 사양 복사
 * @returns
 */
export const copyMdIvesMdlInfo = async (elmPrjId: string, ivesMdlId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/model/copy`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { elmPrjId, ivesMdlId },
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 투자항목 목록 조회
 * @returns
 */
export const findMdIvesArticleList = async (condition: MdIvesMdlCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/article`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesArticle[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesArticle[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 투자항목 목록 저장
 * @returns
 */
export const saveMdIvesArticleList = async (masterData: MdIvesArticle[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/article`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 투자항목 merge
 * @param elmPrjId
 * @param ivesMdlId
 * @param mdlSmlyId
 * @returns
 */
export const mergeMdIvesArticle = async (
  elmPrjId: string,
  ivesMdlId: string,
  mdlSmlyId: string
) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/article/merge`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { elmPrjId, ivesMdlId, mdlSmlyId },
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 투자항목 Popup 목록 조회
 * @returns
 */
export const findMdIvesArticlePopupList = async (condition: MdIvesMdlCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/article-popup`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesArticle[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesArticle[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 상세점검 목록 조회
 * @returns
 */
export const findMdIvesDtlIsptList = async (condition: MdIvesDtlIspt) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/detail-inspect`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesDtlIspt[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesDtlIspt[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 상세점검 목록 저장
 * @returns
 */
export const saveMdIvesDtlIsptList = async (masterData: MdIvesDtlIspt[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/detail-inspect`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 상세점검 행추가 저장
 * @returns
 */
export const saveMdIvesDtlIsptListRow = async (masterData: MdIvesDtlIspt[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/detail-inspect-row`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 상세점검 merge
 * @param elmPrjId
 * @param ivesMdlId
 * @param mdlSmlyId
 * @returns
 */
export const mergeMdIvesDtlIspt = async (
  elmPrjId: string,
  ivesMdlId: string,
  mdlSmlyId: string
) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/detail-inspect/merge`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { elmPrjId, ivesMdlId, mdlSmlyId },
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 상세점검 -> 투자항목으로 업데이트
 * @returns
 */
export const updateMdIvesDtlIsptListByArticle = async (elmPrjId: string, ivesMdlId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/detail-inspect/article-update`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: {
      elmPrjId,
      ivesMdlId,
    },
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 상세점검 Popup 목록 조회
 * @returns
 */
export const findMdIvesDtlIsptPopupList = async (condition: MdDtlIsptCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/detail-inspect-popup`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdDtlIspt[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdDtlIspt[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 라인/설비대수 점검 목록 조회
 * @param ivesMdlId 투자모델ID
 * @param elmPrjId 프로젝트iD
 * @param prdnLnTpCd 생산라인유형코드
 * @returns
 */
export const findMdIvesLnEqpIsptList = async (ivesMdlId, elmPrjId = '', prdnLnTpCd = '') => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/line/equipment/inspection`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ivesMdlId,
      elmPrjId,
      prdnLnTpCd,
    }),
  };
  const response: CommonResponse<MdIvesMdlEqpLnIspt[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlEqpLnIspt[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 라인/설비대수 점검 목록 조회 pivot
 * @param ivesMdlId 투자모델ID
 * @param elmPrjId 프로젝트iD
 * @param prdnLnTpCd 생산라인유형코드
 * @returns
 */
export const findMdIvesLnEqpIsptPivotList = async (ivesMdlId, elmPrjId = '', prdnLnTpCd = '') => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/line/equipment/inspection/pivot`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ivesMdlId,
      elmPrjId,
      prdnLnTpCd,
    }),
  };
  const response: CommonResponse<MdIvesMdlEqpLnIspt[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlEqpLnIspt[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 라인/설비대수 점검 목록 저장
 * @param rowData
 */
export const saveMdIvesLnEqpIsptList = async (rowData: MdIvesMdlEqpLnIspt[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/line/equipment/inspection`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: rowData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 라인/설비 추가 팝업 생산라인 목록 조회(기준정보)
 * @param elmPrjId 프로젝트ID", example = "PRJ-00010"
 * @param prdnLnTpCd 공정(Multi)", example = "E"
 * @param bildPlntCd 플랜트(Multi)", example = "WA1,OT1"
 * @param bldoId 동(Multi)", example = "BD02"
 * @param eqclId 설비군(Multi)", example = "MIX"
 * @returns
 */
export const findMdIvesMdlLnEqpList = async (
  elmPrjId,
  prdnLnTpCd = '',
  bildPlntCd = '',
  bldoId = '',
  eqclId = ''
) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/line/equipment`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      elmPrjId,
      prdnLnTpCd,
      bildPlntCd,
      bldoId,
      eqclId,
    }),
  };
  const response: CommonResponse<MdIvesMdlLnEqp[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlLnEqp[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 라인/설비 추가 팝업 기등록 목록 조회
 * @param ivesMdlId description = "투자모델ID", example = "IM-00001"
 * @param elmPrjId description = "프로젝트 ID", example = "PRJ-00010"
 * @returns
 */
export const findMdIvesMdlLnEqpPreRegistList = async (ivesMdlId, elmPrjId = '') => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/line/checked-equipment`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ivesMdlId,
      elmPrjId,
    }),
  };
  const response: CommonResponse<MdIvesMdlLnEqp[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlLnEqp[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 검토모델 사양정보 조회
 * @param condition
 */
export const findReviewModel = async (condition: MdIvesMdlCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/review-model`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesMdlSmlyScor[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlSmlyScor[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 유사도 모델 및 점수 정보 조회
 * @param condition
 */
export const findSimilarModelsWithScoreList = async (condition: MdIvesMdlCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/similar-model`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesMdlSmly[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesMdlSmly[];
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 유사도 모델 및 점수 정보 저장(유사모델 산출)
 * @param condition
 */
export const saveSimilarModelsWithScore = async (masterData: MdIvesMdlSmly) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/similar-model`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 유사모델 지정
 * @param masterData
 */
export const confirmSimilarModel = async (masterData: MdIvesMdlSmly) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/similar-model/confirm`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};

/**
 * 형개발투자비 산출 등록/조회 > 형개발 투자비검토 > 투자실적 이력 조회(단가 조회)
 * @param condition
 */
export const findIvesPfrsltList = async (condition: MdIvesPerformanceResultCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/performance-result`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesPerformanceResult[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesPerformanceResult[];
};
